import React from "react";
import PropTypes from "prop-types";
import styles from "components/tours/tour-content.scss";
import { Button } from "components/common/button";

export const TourContent = ({ content, last = false, onClick }) => (
  <div>
    {content}
    <div className={ styles.navigation }>
      <Button onClick={ () => onClick() } primary>{ last ? "Finish" : "Next" }</Button>
    </div>
  </div>
);

TourContent.defaultProps = {
  last: false
};

TourContent.propTypes = {
  content: PropTypes.string.isRequired,
  last: PropTypes.bool,
  onClick: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/tours/tour-content.jsx